import last from 'lodash/last';
import { createSelector } from 'reselect';

export const getInteractionHistory = state => state.interactionHistory;

export const getLastTraceEntries = trace => {
  const lastSegment = last(trace) || {};
  const lastPage = last(lastSegment.pages) || {};
  const lastField = last(lastPage.fields) || '';
  return { lastSegment, lastPage, lastField };
};

export const get = createSelector(
  getInteractionHistory,
  interactionHistory => interactionHistory
);

export const getLastTrace = createSelector(
  getInteractionHistory,
  interactionHistory => {
    const { lastField, lastPage, lastSegment } = getLastTraceEntries(
      interactionHistory.trace
    );

    return {
      lastSegment: lastSegment.name || '',
      lastPage: lastPage.name || '',
      lastField,
    };
  }
);
